import { Component, OnInit } from '@angular/core';
import { eingsoft } from '../../eingsoft';
import { QRcode } from '../../QRcode';

@Component({
  selector: 'app-emop-sidebar-about',
  templateUrl: './emop-sidebar-about.component.html',
  styleUrls: ['./emop-sidebar-about.component.scss']
})
export class EmopSidebarAboutComponent implements OnInit {
  QRcode = QRcode;
  eingsoft = eingsoft;
  constructor() { }

  ngOnInit(): void {
  }

}
